/**
 * A failed void arrives as {status: 2, data: '<CODE>'} -- axios rejects the 400 and processError
 * reads response.data.message into `data`.
 *
 * The backend diagnoses a rejected void by reading the code back from EFS (getMoneyCodeById), so
 * these codes say *why* it was refused rather than just that it failed. VOID_FAILED is the
 * catch-all the backend sends when it could not establish a reason.
 */
export function getVoidErrorKey(code) {
    switch (code) {
        case 'VOID_FAILED_ALREADY_VOIDED':
            return 'message.void_failed_already_voided';
        case 'VOID_FAILED_CODE_USED':
            return 'message.void_failed_code_used';
        case 'VOID_FAILED_CODE_NOT_FOUND':
            return 'message.void_failed_code_not_found';
        default:
            return 'message.void_failed';
    }
}

/**
 * True when the backend reconciled our copy of the row as part of refusing the void, so the list
 * is stale and needs re-reading. Only already-voided does this -- the other refusals change
 * nothing server-side.
 */
export function voidErrorNeedsRefresh(code) {
    return code === 'VOID_FAILED_ALREADY_VOIDED';
}
